module.exports = __webpack_public_path__ + "img/1479619533.ed24287c.jpg";